import { render, staticRenderFns } from "./ViewSubscriptions.vue?vue&type=template&id=85917eb8"
import script from "./ViewSubscriptions.vue?vue&type=script&lang=js"
export * from "./ViewSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports